/*eslint quote-props: off*/

const tr = {
  person: {
    attributes: {
      id: 'ID',
      name: 'Nome',
      cell_phone: 'Telefone',
      created_at: 'Criado em',
      email: 'E-mail',
      cpf: 'CPF',
      expires_at: 'Expira em',
      born_date: 'Data de nascimento',
      uuid: 'Identificação única',
      last_access: 'Ultimo acesso em',
      cns: 'CNS',
      phone_country_prefix: 'Prefixo de telefone',
      signature_first_date: 'Dia inicial de assinatura',
      reason_to_use: 'Razão de usar',
      signature: 'Assinatura',
      platform: 'Plataforma de uso',
      doctor_interest: 'Interesse no pacote médico',
      nationality: 'Nacionalidade',
      device_language: 'Linguagem do dispositivo',
      store_location: 'País da loja',
      app_version: 'Versão do APP (24h)',
      owner_partner: 'Administrador de parceria',
      packs_enable: 'Adicionais habilitados',
      specialties: 'Adicionais de Especialistas',
      doctor_specialties: 'Especialidades do Médico',
      image_base64: 'Imagem',
      role: 'Regra',
      signup_messages: 'Observações de cadastro',
      device_info: 'Informações de dispositivo',
      password: 'Senha',
      partner_id: 'Parceiro Promocional',
      partner_supplier_id: 'Parceiro Fornecedor',
      corporate_partner: 'Parceiro Empresa',
      enabledBy: 'Habilitado por',
      enabledIn: 'Habilitado em',
      pack: 'Adicional',
      packPackage: 'Pacote',
      packPackages: 'Pacotes',
      partner: 'Empresa',
      specialty: 'Especialidade',
      postal_code: 'CEP',
      neighborhood: 'Bairro',
      street: 'Rua',
      number: 'N°',
      city: 'Cidade',
      years_old: 'Anos de idade',
      crm: 'CRM',
      crp: 'CRP',
      gender: 'Gênero sexual',
      canceledDate: 'Cancelado em',
      cancel_date: 'Data de cancelamento',
      has_benefits_club: 'Habilitar Club Televida?',
      is_regulator: 'Regulador',
      reports_only: 'Relatório Station',
    },
    roles: {
      doctor: 'Médico',
      attendant: 'Atendente',
      partner_role: 'Parceiro',
      admin: 'Adminstrador',
      customer: 'Usuário',
      marketing: 'Marketing',
    },
    extras: {
      count_appointments: 'Total de Consultas',
      newPerson: 'Novo Cliente',
      editPerson: 'Editando Cliente',
      showPerson: 'Visualizando cliente',
      examsPerson: 'Solicitação de exames para',
      child: 'Convidado - Participa de um grupo',
      father: 'Master - Possui algum grupo com  outros integrantes',
      purchased_addon_type: 'Tipo de Adicional já contratado',
      actived_addon_type: 'Adicional ativo',
      signature_first_date: 'Data primeira assinatura (aprovada)',
      purchased_addon_id: 'ID do adicional contratado',
      signature_enabled: 'Assinatura ativa',
      purchased_and_actived_addon_type: 'Tipo de Adicional contratado e ativo',
      stats: 'Estatísticas',
      created_group: 'Master - Já criou um grupo',
      free_period: 'Período de 3 dias',
      first_card_add: 'Data primeira assinatura',
      last_sign_state: 'Status da ultima transação',
      pilot: 'Habilitado como piloto',
      teams: 'Grupos',
      user_teams: 'Usuários do grupo',
      team_owner: 'Dono do grupo',
      send: 'Enviar',
      sending: 'Enviando ...',
      sended: 'Enviado',
      no_partner: 'Nenhum Parceiro',
      partner: 'Parceiro',
      users_to_import: 'Usuário(s) selecionados',
      importation_file: 'Arquivo de importação',
      tooltip_import_users: 'Formatos esperados: XLSX',
      message_import_users: 'Dados enviados com sucesso!',
      errors_occured: 'Ocorreu erro!',
      dependents: 'Dependentes',
      manage_packages: 'Gerenciar adicionais',
      packsOfUser: 'Adicionais de',
      newPack: 'Novo adicional',
      noPacks: 'Não há adicionais habilitado',
      noSpecialties: 'Não há especiliadades vinculadas',
      activePackageSuccess: 'Adicional habilitado com sucesso!',
      removePackageError: 'Erro ao habilitar o adicional!',
      newMedicalAppointments: 'Nova consulta médica',
      newExam: 'Solicitar exames',
      select_specialty:
        'Por favor selecione alguma especialidade para Médico Especialista',
      pack_packages: 'Pacotes',
      noPack_packages: 'Não há pacotes vinculadas',
      edit_package: 'Editar adicional',
    },
    routes: {
      def: 'Percursos: {{routes}}',
      average_speeed: 'Velocidade média: {{average_speed}} km/h',
      max_speed: 'Velocidade máxima: {{max_speed}} km/h',
      total_kilometers: 'Quilometragem total: {{km_total}} km',
      cell_phone_usage: 'Uso de celular:',
      high_speed: 'Velocidade alta:',
      abrupt_braking: 'Freada Brusca:',
      fast_acceleration: 'Aceleração rápida:',
    },
    toast: {
      push_success: 'Notificação agendada com sucesso',
      push_fail: 'Infelizmente seu agendamento falhou, tente novamente',
      cep_not_found: 'CEP não encontrado',
    },
    tabs: {
      profile: 'Perfil',
      medical_appointments: 'Consultas Médicas',
      medical_record: 'Prontuário Médico',
      location: 'Localização',
      sentiance: 'Sentiance',
      dependents: 'Dependentes',
      user_teams: 'Grupos',
      security: 'Seguro',
      sus_report: 'Prontuário SUS',
      sus_service: 'Atendimento SUS',
    },

    defSingular: 'Cliente',
    defPlural: 'Clientes',
    defRoutes: 'Linha do tempo',
  },
};

export default tr;
